import { jsx as _jsx } from "react/jsx-runtime";
import { T } from '../../i18n';
export const FallbackLoading = () => {
    return (_jsx("div", { children: _jsx(T, { id: "Generics.LoadingDotDotDot", defaultMessage: "Loading..." }, void 0) }, void 0));
};
//# sourceMappingURL=FallbackLoading.js.map